import type { IconSvgProps } from '../iconProps';

const TextIcon = ({ theme: _theme, ...props }: IconSvgProps) => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.7929 2.5H6.75C6.47385 2.5 6.25 2.72385 6.25 3V22.5C6.25 22.7761 6.47385 23 6.75 23H21.25C21.5261 23 21.75 22.7761 21.75 22.5V7.4571C21.75 7.3245 21.6973 7.19732 21.6035 7.10355L17.1465 2.64645C17.0527 2.55268 16.9255 2.5 16.7929 2.5Z"
      fill="white"
      stroke="#2D98DB"
      strokeMiterlimit="10"
    />
    <path
      d="M16.75 2.5V7C16.75 7.27615 16.9739 7.5 17.25 7.5H21.75"
      stroke="#2D98DB"
      strokeMiterlimit="10"
    />
    <path
      d="M4 13.75H15.5C17.433 13.75 19 15.317 19 17.25C19 19.183 17.433 20.75 15.5 20.75H4V13.75Z"
      fill="#2D98DB"
    />
    <path
      d="M9.019 15.4275H7.678L7.882 15.0855V19.3125H7.231V15.0855L7.456 15.4275H6.097V14.8875H9.019V15.4275ZM10.8553 16.8585L10.8493 17.3895L9.43328 14.8875H10.1623L11.2633 16.9485H10.9123L12.0043 14.8875H12.7333L11.3293 17.3895L11.3263 16.8585L12.7783 19.3125H12.0463L10.9003 17.2995H11.2753L10.1263 19.3125H9.39728L10.8553 16.8585ZM16.0795 15.4275H14.7385L14.9425 15.0855V19.3125H14.2915V15.0855L14.5165 15.4275H13.1575V14.8875H16.0795V15.4275Z"
      fill="white"
    />
  </svg>
);

export default TextIcon;
